import { useContext } from "react";
import { AuthContext } from "../App";
import { Navigate, Outlet } from "react-router-dom";


const PrivatePages = () => {

    const { pAuth, setPAuth } = useContext(AuthContext);

    // return pAuth ? <div>Hello Private</div> : <div>Otherwise</div>
    return pAuth ? <Outlet /> : <div>404 Page</div>
}

export default PrivatePages; 